// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3wCG-","content":"GlobalSearch_content__VyYaQ"};